<template>
    <div class="canvas-deliverable">


        <div class="card mb-3" v-if="has_deliverable && !locked">
            <div class="card-body">
                <a class="image" v-if="deliverable_url" target="_blank" :href="uploads.url( deliverable_url )">
                    <img :src="absolute_deliverable_preview_url" alt="">
                </a>
                <div class="text" v-if="deliverable?.text">
                    <span class="quote-left">“</span>
                    {{ utils.nl2br( deliverable.text ) }}
                    <span class="quote-right">”</span>
                </div>
            </div>
        </div>


        <div v-if="locked" class="locked-info">
            <img src="/images/icons/lock.svg" class="lock" alt="">
            <span v-if="unlock_mission === 'all'">
                At the end of this stage, upload evidence of your learning.
            </span>
            <span v-else-if="unlock_mission === 'one'">
                At the end of this stage, upload evidence of your learning.
            </span>
        </div>
        <temlate v-else>
            <div>
                <button class="btn btn-lg btn-secondary"
                        @click.prevent.stop="edit()">
                    <template v-if="deliverable.text || deliverable.file">
                        <icon-check size="18"/>
                        Update Stage Deliverable
                    </template>
                    <template v-else>
                        <icon-check size="18"/>
                        Complete Stage Mission
                    </template>
                </button>
            </div>
        </temlate>


        <modal :id="utils.randomId({prefix: 'modal'})"
               :show="modal.enabled"
               v-if="modal.enabled"
               size="lg"
               @close="close()">
            <template #title>
                Stage Deliverable
            </template>

            <markdown-text :content="mission.deliverable"/>

            <div class="form-group">
                <textarea class="form-control" placeholder="Add deliverable text here" v-model="modal.text"></textarea>
            </div>

            <div class="form-group">
                <file-uploader class="my-3" v-model="modal.file"/>
            </div>

            <template #footer>
                <button type="button"
                        @click.stop.prevent="close()"
                        class="btn btn-warning">Cancel</button>
                <button type="button"
                        @click.stop.prevent="save()"
                        class="btn btn-success ml-auto">Save</button>
            </template>
        </modal>

    </div>
</template>

<script>
import Modal from "@/Components/Common/Modal";
import FileUploader from "@/Components/Common/FileUploader";
import MarkdownText from "@/Components/Common/MarkdownText";
import uploads from "@/mixins/uploads";
import utils from "@/mixins/utils";
import {mapActions} from "vuex";
import IconCheck from "@/Icons/IconCheck";
export default {
    name: "CanvasDeliverable",
    components: {IconCheck, Modal, FileUploader, MarkdownText},
    mixins: [uploads, utils],
    props: ['canvas', 'path', 'stage', 'locked'],
    emits: ['update'],

    data(){
        return {
            modal: {
                enabled: false,
                key: '',
                title: '',
                text: '',
                file: null,
            },
        }
    },

    computed: {

        path_fragment_key(){
            return `stage_${this.stage}_misson_details`;
        },

        canvas_fragment_key(){
            return `stage_${this.stage}_mission_deliverable`;
        },

        mission(){
            if( typeof this.path.fragments[ this.path_fragment_key ] !== 'undefined' ){
                return this.path.fragments[ this.path_fragment_key ];
            }
            return {};
        },

        deliverable: {
            get(){
                if( typeof this.canvas?.fragments[ this.canvas_fragment_key ] !== 'undefined' ){
                    return this.canvas.fragments[ this.canvas_fragment_key ];
                }
                return {
                    file: null,
                    text: '',
                };
            },

            set(val){
                this.canvas.fragments[ this.canvas_fragment_key ] = val;
            }
        },

        has_deliverable(){
            return this.deliverable_url || this.deliverable?.text;
        },

        absolute_deliverable_preview_url(){
            if( this.deliverable_preview_url ){
                return this.uploads.image( this.deliverable_preview_url, { w: 600, h: 600, c: false } );
            }
            return null;
        },

        deliverable_preview_url(){
            if( this.deliverable?.file?.preview_url ) return this.deliverable.file.preview_url;
            if( this.deliverable_url ) return this.deliverable_url;
            return null;
        },

        deliverable_url(){
            if( this.deliverable?.file?.url ) return this.deliverable.file.url;
            return null;
        },

        unlock_mission(){
            const locked = this.project?.meta?.unlock_mission;
            return locked ? locked : 'one';
        },

    },


    methods: {

        ...mapActions('repositories', {
            updateRepo: 'updateRepository',
        }),

        edit(){
            this.modal.text = this.deliverable?.text;
            this.modal.file = this.deliverable?.file;
            this.modal.enabled  = true;
        },

        close(){
            this.modal.text = '';
            this.modal.file = null;
            this.modal.enabled  = false;
        },

        save(){

            const deliverable = {
                text: this.modal.text,
                file: this.modal.file,
            };

            this.deliverable = deliverable;

            const fragments = {};
            fragments[ this.canvas_fragment_key ] = deliverable;
            this.updateRepo({scope: this.canvas.scope, fragments})
                .then(() => {

                    if( this.stage === 'share' ){
                        if( window.userGuiding ){
                            window.userGuiding.previewGuide(37283);
                        }
                    }

                    this.$emit('update', this.deliverable);
                });

            this.close();
        }

    }

}
</script>

<style lang="scss" scoped>
.card-body{
    display: flex;
    align-items: center;
    padding: 1rem;
    flex-direction: column;

    @include media-breakpoint-up(md){
        padding: 2rem;
    }

    @include media-breakpoint-up(lg){
        flex-direction: row;
    }

}
.image{
    margin-right: 1rem;
    margin-bottom: 1rem;
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;

    &:hover{
        img{
            opacity: 0.3;
            background: $dark;
        }
        &:after{
            opacity: 1;
        }
    }

    &:after{
        content: 'Click to view';
        position: absolute;
        width: 100%;
        text-align: center;
        top: 50%;
        transform: translate( 0, -50% );
        font-size: 1.2rem;
        font-weight: $font-weight-bold;
        opacity: 0;
        transition: opacity .3s;
    }

    img{
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        transition: opacity .3s, background-color .3s;
        border-radius: 1rem;
    }
}
.text{
    flex-grow: 1;
    text-align: center;
    font-size: 2rem;
    font-weight: $font-weight-bold;
    max-width: 900px;
    margin: auto;
    word-break: break-word;

    @include media-breakpoint-up(md){
        font-size: 2.6rem;
    }
}
.quote-left, .quote-right{
    position: relative;
    color: $secondary;
    line-height: 0;
    font-size: 2em;

    @include media-breakpoint-up(md){
        font-size: 3em;
    }
}
.quote-left{
    //left: -.3em;
    top: .2em;
}
.quote-right{
    //right: -.3em;
    bottom: -.6em;
}
.locked-info{
    margin-top: 2rem;
    display: flex;
    align-items: center;
    background: lighten($danger, 30%);
    padding: 1rem;
    border-radius: 1rem;
    box-shadow: rgba($danger, 0.1) 0 3px 5px;

    .lock{
        flex: 0 0 3rem;
        width: 3rem;
    }
}

</style>
